export type AppLanguageCode = 'fr' | 'en' | 'es' | 'pt';
export type ApiLanguage = 'FRENCH' | 'ENGLISH' | 'SPANISH' | 'PORTUGUESE';

type AppLanguage = {
  code: AppLanguageCode;
  apiValue: ApiLanguage;
  nativeLabel: string;
  locale: string;
};

export const APP_LANGUAGES: readonly AppLanguage[] = [
  { code: 'fr', apiValue: 'FRENCH', nativeLabel: 'Français', locale: 'fr-FR' },
  { code: 'en', apiValue: 'ENGLISH', nativeLabel: 'English', locale: 'en-US' },
  { code: 'es', apiValue: 'SPANISH', nativeLabel: 'Español', locale: 'es-ES' },
  { code: 'pt', apiValue: 'PORTUGUESE', nativeLabel: 'Português', locale: 'pt-BR' },
];

export const DEFAULT_LANGUAGE = APP_LANGUAGES[0];

export const LANGUAGE_STORAGE_KEY = 'i18nextLng';

export const SUPPORTED_LANGUAGE_CODES: AppLanguageCode[] = APP_LANGUAGES.map((l) => l.code);

export const API_LANGUAGES = APP_LANGUAGES.map((l) => l.apiValue) as [
  ApiLanguage,
  ...ApiLanguage[],
];

export function findAppLanguage(lng: string | null | undefined): AppLanguage | undefined {
  const code = (lng ?? '').slice(0, 2).toLowerCase();
  return APP_LANGUAGES.find((l) => l.code === code);
}

/** Langue i18n connue la plus proche (`pt-BR` → `pt`), le français à défaut. */
export function getAppLanguage(lng: string | null | undefined): AppLanguage {
  return findAppLanguage(lng) ?? DEFAULT_LANGUAGE;
}

export function getAppLanguageFromApi(language: string | null | undefined): AppLanguage {
  return APP_LANGUAGES.find((l) => l.apiValue === language) ?? DEFAULT_LANGUAGE;
}
